var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataProcessing"},[(_vm.url)?_c('iframe',{staticClass:"iframe_div",attrs:{"src":_vm.url}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }